<template>
  <div v-if="!!criterion.parentId && criterion.type !== 'SCORE_CONTAINER'" class="panel panel-collapsed">
    <div class="panel-hdr clickable" @click="toggleCollapse">
      <h2>
        {{ criterion.name }}
        <span class="badge ml-2" :class="badgeClass">{{ assessment }}</span>
      </h2>

      <div class="panel-toolbar">
        <button class="btn btn-panel">
          <tooltip v-if="model.collapse.$model" text="Rozwiń">
            <i class="fal fa-angle-double-down" />
          </tooltip>

          <tooltip v-else text="Zwiń">
            <i class="fal fa-angle-double-up" />
          </tooltip>
        </button>
      </div>
    </div>

    <div class="panel-container collapse" :class="{ show: !model.collapse.$model }">
      <div class="panel-content">
        <p v-if="criterion.description">{{ criterion.description }}</p>

        <div v-if="criterion.type === 'BOOL'" class="mb-2">
          <w-radio-list :model="model.passed" :values="options" />
        </div>

        <div v-else>
          <w-input type="number" :model="model.value" />
        </div>

        <w-textarea v-if="model.passed.$model !== null || criterion.type === 'SCORE'" :model="model.description" />
      </div>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Tooltip from '@/components/tooltip/Tooltip';

// @vuese
// Pojedynczy element oceny
export default {
  components: {
    ...components,
    Tooltip
  },
  props: {
    // Kryterium oceny
    criterion: {
      type: Object,
      required: true
    },
    // Model oceny
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: [
        { value: 1, text: 'Tak', badge: 'badge-success' },
        { value: 2, text: 'Nie dotyczy', badge: 'badge-secondary' },
        { value: 3, text: 'Do uzupełnienia', badge: 'badge-warning' },
        { value: 4, text: 'Nie', badge: 'badge-danger' }
      ]
    };
  },
  computed: {
    selectedOption() {
      return this.options.find(option => option.value === this.model.passed.$model);
    },
    assessment() {
      if (this.criterion.type === 'BOOL') {
        return this.selectedOption?.text || '';
      } else {
        return this.model.value.$value;
      }
    },
    badgeClass() {
      if (this.criterion.type === 'BOOL') {
        return this.selectedOption?.badge;
      }
      return 'badge-secondary';
    }
  },
  methods: {
    // @vuese
    // Rozwija panel kryterium
    toggleCollapse() {
      this.model.collapse.$setData(!this.model.collapse.$model);
    }
  }
};
</script>

<style>
.page-content .panel {
  margin-bottom: 0.2rem;
}
</style>
